import styled, { keyframes } from 'styled-components';
import { cn } from '@restworld/utils-common';

const cardFadeIn = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const ManualEntryPromptWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col items-center gap-1 w-full', className)} {...props} />
);

export const ManualEntryPromptText = ({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-center text-sm w-full text-[#858591] m-0', className)} {...props} />
);

export const ManualEntryPromptHint = ({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-center text-xs w-full m-0 text-neutral-200', className)} {...props} />
);

export const ManualEntryPromptLink = ({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) => (
  <span className={cn('underline cursor-pointer font-medium text-[#666676]', className)} {...props} />
);

/* Card shown when Google returns no usable result: a bordered, neutral-background
   block that gives the manual-entry path stronger affordance than the inline link. */
export const ManualEntryCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  text-align: center;
  padding: 1.5rem;
  border-radius: 1rem;
  border: 1px solid var(--color-neutral-40, #e5e5e5);
  background: var(--color-neutral-10, #fafafa);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  animation: ${cardFadeIn} 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ManualEntryCardHeading = ({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-base font-semibold text-neutral-700 w-full m-0', className)} {...props} />
);

export const ManualEntryCardHint = ({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-center text-sm w-full m-0 text-neutral-200', className)} {...props} />
);

export const ManualEntryBody = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col flex-1 w-full items-start px-10 pb-10 pt-6 gap-6', className)} {...props} />
);

export const ManualFieldWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col w-full gap-2', className)} {...props} />
);

export const ManualFieldLabel = ({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) => (
  <label className={cn('m-0 font-medium text-base leading-tight text-neutral-700', className)} {...props} />
);
